import { makeAutoObservable, runInAction } from 'mobx'
import { LogsActivitiesServices } from '~/shared/api/services/user-logs-activities'
import {
  FilterActivities,
  UserLogsActivitiesType,
} from '~/shared/api/services/user-logs-activities/types'
import { handleAxiosError } from '~/shared/lib'
import { LoadersActivities } from './types'

export class UserLogsActivitiesStore {
  userActivityLogs: UserLogsActivitiesType[] = []

  loaders: LoadersActivities = {
    userActivityLogs: false,
    loadMoreUserActivityLogs: false,
  }

  requestSettings = {
    limit: 20,
    offset: 0,
    isAllLoaded: false,
  }

  constructor() {
    makeAutoObservable(this)
  }

  activeLoader = (key: keyof LoadersActivities) => {
    this.loaders = { ...this.loaders, [key]: true }
  }

  closeLoader = (key: keyof LoadersActivities) => {
    this.loaders = { ...this.loaders, [key]: false }
  }

  getActivities = async (options?: {
    action?: 'loadMoreUserActivityLogs'
    filters?: FilterActivities
  }) => {
    const { action, filters } = options || {}

    if (
      action === 'loadMoreUserActivityLogs' &&
      this.requestSettings.isAllLoaded
    ) {
      return
    }

    this.activeLoader(action || 'userActivityLogs')

    try {
      const params = {
        limit: this.requestSettings.limit,
        offset:
          action !== 'loadMoreUserActivityLogs'
            ? 0
            : this.requestSettings.offset,
        textQuery: filters?.textQuery || null,
        subjectType: filters?.subjectType || null,
        event: filters?.event || null,
        causerId: filters?.causerId || null,
        dateTimeStart: filters?.dateTimeStart ?? null,
        dateTimeEnd: filters?.dateTimeEnd ?? null,
      }

      const { data } = await LogsActivitiesServices.getLogsActivities({
        params,
      })

      if (action === 'loadMoreUserActivityLogs') {
        runInAction(() => {
          this.userActivityLogs = [...this.userActivityLogs, ...data]
        })
      } else {
        runInAction(() => {
          this.userActivityLogs = data
        })
      }

      runInAction(() => {
        this.requestSettings = {
          ...this.requestSettings,
          isAllLoaded: data.length < this.requestSettings.limit,
          offset:
            action === 'loadMoreUserActivityLogs'
              ? this.requestSettings.offset + this.requestSettings.limit
              : this.requestSettings.limit,
        }
      })

      return data
    } catch (error) {
      const errorMessage = handleAxiosError(error)
      throw new Error(errorMessage)
    } finally {
      this.closeLoader(action || 'userActivityLogs')
    }
  }
}

export default UserLogsActivitiesStore
